var t=t=>"string"!=typeof t?t:t.replace(/([=$<>^])/g,t=>`\\u${t.charCodeAt(0).toString(16)}`);export{t as sanitizeUserInput};
//# sourceMappingURL=sanitizeUserInput.js.map